import {useQuery} from '@tanstack/react-query';
import {QUERY_KEYS} from 'infra/libs/react-query/queryKeys';
import {NeighborhoodsDentalGuide} from 'domain/usecases';
import {UseDistrictsGuideQueryParams} from './types';
import {getDistrictsGuide} from '../../services/getDistrictsGuide';

export function useDistrictsGuideQuery({enabled, ...params}: UseDistrictsGuideQueryParams) {
	const {cdUf, nmCidade, nmLocal, distancia, cdPlanoANS, tpLocalidade} = params;
	return useQuery<NeighborhoodsDentalGuide[]>({
		queryKey: [
			QUERY_KEYS.DISTRICTS_GUIDE,
			cdUf,
			nmCidade,
			nmLocal,
			distancia,
			cdPlanoANS,
			tpLocalidade,
		],
		queryFn: ({signal}) =>
			getDistrictsGuide({
				...(!nmLocal && {cdUf}),
				...(!nmLocal && {nmCidade}),
				...(nmLocal && {nmLocal}),
				...(nmLocal && {distancia: distancia || '50'}),
				tpLocalidade: nmLocal ? 'Coordenadas' : 'Cidade',
				cdPlanoANS,
				signal,
			}),
		enabled,
	});
}
